// extracted by mini-css-extract-plugin
module.exports = {"input":"Search_input__2zEIH","btn":"Search_btn__fnGFA"};